import { render } from "./Edit.vue?vue&type=template&id=7528ef98&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=7528ef98&lang=less&scoped=true"
import "./Edit.vue?vue&type=style&index=1&id=7528ef98&lang=css"
script.render = render
script.__scopeId = "data-v-7528ef98"

export default script